import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import * as moment from 'moment';
import { memberPortal } from "../member-portal";
import { bookingFormCommon } from "../c005-bookingform-common";
import { adobeDataLayerWrapper } from "../adobeDataLayerMethod";
import * as numeral from 'numeral';

export class memberPointsExchange {
	private partnerPointsExcForm:any   = $('#binfinitepoints-exchange-miles-form');
	$instance:any;
	private bookingformcommon = new bookingFormCommon();
    private adobeDataLayer = new adobeDataLayerWrapper()
	private initialBal:any;
	private minEnrichMilesTable:any;
	private sunwaypointExcList:any;
	
	
    enrichstatus():any
    {
        let populateurl:string = '';
		if (window.location.hostname === 'localhost' && window.location.port == '5000') {
			populateurl = '/dummy-data/enrichstatus.json';
		}
		else {
			populateurl = '/bin/services/new/getEnrichSummaryLCP';
		}
		let _self = this;
		let bcommon = _self.bookingformcommon;
        let adobeData = _self.adobeDataLayer;
        let enrichPoints = null;
        let rangemarks = null;
        let enrichTier = null;
        let carryFwdAmount = null;
        let Sumtotal = null;
        let cardExpiry = null;
        let cardExpiryLifeTime = "LIFETIME";
        let cardExpiryCookieVallue = adobeData.getCookie('lifetimeCard');
        if (cardExpiryCookieVallue === "true") {
            cardExpiry = cardExpiryLifeTime;
        } else {
            cardExpiry = cardExpiryCookieVallue;
        }
		bcommon.preloader();
		$.ajax({
			type: 'GET',
			url:populateurl,
			success: function(msg:any) {
				if(typeof msg==='string'){
				msg = JSON.parse(msg);
				}else{
					msg=msg;
                }
                let rangemarks=msg.rangemarker;
                let enrichPoints=msg.enrichPoints;
                enrichTier=msg.enrichTier;
                let carryFwdAmount = msg.carryFwdAmount;
                Sumtotal = (+enrichPoints) + (+enrichPoints);
                //cardExpiry = $(".card--cardvalidtill").find(".date").val();
                if(msg.rangemarker!="" && msg.rangemarker!=undefined){
                var consSplitComma=rangemarks.split(',');
                var markerThree = consSplitComma[2];
                var markerOne = consSplitComma[0];								
                var markerTwo = consSplitComma[1];
                //enrichPoints = msg.actualEnrichPts;
                $('.range__pointtwo').css('left', Math.floor((markerOne / markerThree ) * 100)+'%');
                $('.range__pointthree').css('left', Math.floor((markerTwo / markerThree ) * 100)+'%');
                $('.enrich_points').text(enrichPoints);
                // $('.range-slider').attr("max", markerThree);
                _self.rangeslider();
                _self.manageTheStatusOfMarker(enrichPoints, {
                    "one": markerOne, 
                    "two": markerTwo, 
                    "three": markerThree
                });
                var today = moment(new Date()).format('DD/MM/YYYY');
                var trHTML = '';	
                var earnHtml='';
                if(msg.cobrand_fastTrack_val != "" && msg.cobrand_fastTrack_val!=undefined &&msg.cobrand_fastTrack_val == "true"){
                    $('#without_cobrandTrace').addClass('hideclass');
                    $('#without_cobrandTrace').removeClass('showclass');
                    $('#with_cobrandTrace').addClass('showclass');
                    $('#with_cobrandTrace').removeClass('hideclass');
                }else{
                    $('#without_cobrandTrace').addClass('showclass');
                    $('#without_cobrandTrace').removeClass('hideclass');
                    $('#with_cobrandTrace').addClass('hideclass');
                    $('#with_cobrandTrace').removeClass('showclass');
                }
                trHTML += '<div class="enrich_statusmsg"><p>Earned as at <span class="enrich-status-date-bold">'+today+'</span> <span class="enrich-points-number"> '+msg.actualEnrichPts+'</span></p></div>'
                if(msg.isComplement != "" && msg.isComplement!=undefined &&msg.isComplement == "true")
                {
                    earnHtml +='<div class="enrich_statusmsg"><p>Your current tier is complimentary valid until' + msg.complYear+ '<p></div>';
                }else if(msg.isSpouseComplement != "" && msg.isSpouseComplement!=undefined &&msg.isSpouseComplement == "true")
                {
                    earnHtml +='<div class="enrich_statusmsg"><p>Your current tier is spouse complimentary valid until <b>' + msg.complYear+ '</b><p></div>';
                }
                if(msg.retainPoints!="" && msg.retainPoints!="undefined" )
                {
                    earnHtml += '<div class="enrich_statusmsg"><p>Earn another <b>'+msg.retainPoints+'</b> Elite points before <b>'+msg.enrichYear+'</b> to retain <b>'+msg.retainTier+'</b> </p></div>'
                }
                else if(msg.reachPoints!="" && msg.reachPoints!=undefined)
                {
                    earnHtml += '<div class="enrich_statusmsg"><p>Earn another <b>'+msg.reachPoints+'</b> Elite points by <b>'+msg.enrichYear+'</b> to upgrade to <b>'+ msg.reachTier+'</b> </p></div>'                
                }
                if((msg.isCarryFwd != "" && msg.isCarryFwd!=undefined &&msg.isCarryFwd == "true") &&
                (msg.isLifeTimeCrad == "" || msg.isLifeTimeCrad==undefined ))
                //(msg.isComplement == "" || msg.isComplement==undefined ) && (msg.isSpouseComplement == "" || msg.isSpouseComplement==undefined))
                {
                    $('.carryFwdSection').addClass('showclass');
                    $('.carryFwdSection').removeClass('hideclass');
                    $('#nextYr').html(msg.nextYear);
                    $('#elitePts').html(msg.carryFwdAmount);
                }else{
                    $('.carryFwdSection').addClass('hideclass');
                    $('.carryFwdSection').removeClass('showclass');
                }
                $('.enrich-progress-container').append(trHTML);
                $('.enrich-newText').append(earnHtml);
                if(msg.pointExpiryList.length > 0) {
                    $('#status_points').addClass('showclass');
                    $('#status_points').removeClass('hideclass');
                    _self.createPointExpirySection(msg.pointExpiryList);
                } else {
                    $('#status_points').removeClass('showclass');
                    $('#status_points').addClass('hideclass');
                }
                adobeDataLayer.push('pageLoad', {
                    'pageName': 'mas:my:en:enrich-portal:home:summary',
                    'pageType': 'Enrich Summary Page',
                    'attributes': [
                        {
                            'key': 'Enrich-Summary-Page-Enrich-points',
                            'value': enrichPoints
                        },
                        {
                            'key': 'Enrich-Summary-Page-Carry-Forward',
                            'value': carryFwdAmount
                        },
                        {
                            'key': 'Enrich-Summary-Page-Sum-Total',
                            'value': Sumtotal
                        },
                        {
                            'key': 'Enrich-Summary-Page-Card-Expiry',
                            'value': cardExpiry
                        }
                    ]
                });
                bcommon.preloaderClose();
            }}, error: function(error:any) {
                $(".mytravellererror_message").html("Sorry, a general error occurred. Please try again later.");
                bcommon.preloaderClose();
			}
        });
        $("[id^='banner-btn-']").click(function () {
            console.log(this);
            let href = $(this).attr('data-href');
            let id = $(this).attr('id');
            adobeDataLayer.push('click', {
                'pageName': 'mas:my:en:enrich-portal:home:summary',
                'pageType': 'Enrich Summary Page',
                'clickName': 'btn-click:carousel:'+href,
                'componentType': 'Banner',
                'componentName': 'Banner',
                'componentID': id,
                'attributes': [
                    {
                        'key': 'Enrich-Summary-Page-Enrich-points',
                        'value': enrichPoints
                    },
                    {
                        'key': 'Enrich-Summary-Page-Carry-Forward',
                        'value': carryFwdAmount
                    },
                    {
                        'key': 'Enrich-Summary-Page-Sum-Total',
                        'value': rangemarks
                    }

                ]
            });
        })
    }
	manageTheStatusOfMarker(enrichPoints: any, markers: any): any {
        let element = $('.icon-style');
        let childern = $('.radio__control');
        $('#markerOne').text(0);
        $('#markerTwo').text(markers.one);
        $('#markerThree').text(markers.two);
        $('#markerFour').text(markers.three);
        // make all the radio control class as no-active
        childern.map((control: any) => {
            if($(childern[control]).hasClass('active')) {
                $(childern[control]).removeClass('active');
                $(childern[control]).addClass('no-active');
            }
        });
        if(Number(enrichPoints) <= Number(markers.one)) {
            let EP = Number(enrichPoints) + 1;
            EP = Math.floor(EP / (markers.three) * 100);
            $($($('.range__pointone').children()[0]).children()[1]).addClass('active');
            element.css('left', EP+'%');
            $('.range-slider').val(Math.floor(enrichPoints / (markers.three) * 100));
        } else if (Number(enrichPoints) > Number(markers.one) &&  Number(enrichPoints) <= Number(markers.two)) {
            $($($('.range__pointone').children()[0]).children()[1]).addClass('active');
            $($($('.range__pointtwo').children()[0]).children()[1]).addClass('active');
            element.css('left', Math.floor(enrichPoints / (markers.three) * 100)+'%');
            $('.range-slider').val(Math.floor(enrichPoints / (markers.three) * 100));
        } else if (Number(enrichPoints) > Number(markers.two) && Number(enrichPoints) < Number(markers.three)) {
            $($($('.range__pointone').children()[0]).children()[1]).addClass('active');
            $($($('.range__pointtwo').children()[0]).children()[1]).addClass('active');
            $($($('.range__pointthree').children()[0]).children()[1]).addClass('active');
            element.css('left', Math.floor(enrichPoints / (markers.three) * 100)+'%');
            $('.range-slider').val(Math.floor(enrichPoints / (markers.three) * 100));
        } else if (Number(enrichPoints) >= Number(markers.three)){
            $($($('.range__pointone').children()[0]).children()[1]).addClass('active');
            $($($('.range__pointtwo').children()[0]).children()[1]).addClass('active');
            $($($('.range__pointthree').children()[0]).children()[1]).addClass('active');
            $($($('.range__pointfour').children()[0]).children()[1]).addClass('active');
            $('.range-slider').val(100);
            element.css('left', '100%');
        }
    }
    createPointExpirySection(pointExpiryList: any): any {
        let cloneList = JSON.parse(JSON.stringify(pointExpiryList));
        let firstWrapper = cloneList.splice(0, 6);
        let fWC = $('.first-wrapper').children();
        let secondWrapper = cloneList;
        let sWC = $('.second-wrapper').children();
        firstWrapper.map((items: any, index: any) => {
            let row = $(fWC[index]).children();
            $(row[0]).text(items.date);
            $(row[1]).text(items.points);
        });
        secondWrapper.map((items: any, index: any) => {
            let row = $(sWC[index]).children();
            $(row[0]).text(items.date);
            $(row[1]).text(items.points);
        });
    }
	rangeslider(): any {
		// Select all range inputs, watch for change
		$("input[type='range']").change(function() {
            console.log('trigger');
			var el, newPoint, newPlace, offset;
			// Cache this for efficiency
			el = $(this);
            let element = $('.icon-style');
			
			// Measure width of range input
			var width = el.width();
			
			// Figure out placement percentage between left and right of input
			newPoint = (el.val() - el.attr("min")) / (el.attr("max") - el.attr("min"));
			
			offset = -1;
		
            // Prevent bubble from going beyond left or right (unsupported browsers)
            if($('.range__pointone').text()=='30'){
                if (newPoint < 0) { newPlace = 0; }
                else if (newPoint > 1) { newPlace = width; }
                else { newPlace = width * newPoint + offset-1.1; offset -= newPoint-1.1; }             
            }
            else
            {
                if (newPoint < 0) { newPlace = 0; }
                else if (newPoint > 1) { newPlace = width; }
                else { newPlace = width * newPoint + offset-2; offset -= newPoint-2; }
            }		
		}).trigger('change');
			// Fake a change to position bubble at page load
    }
    enrichstatusbenefit()
    { 
        $('a[name="enrich_summary"]').click(function()
        {
            $('#'+this.className).toggleClass('hide');
            var stat_clas=$('.'+this.className)
            $(stat_clas).find('.fa').toggleClass('transform_benefit');
        });
    }
}
declare const window: any;
let scope:Element = document.querySelector('#members-lcpindex-body');
if (scope) {
	try {
    var adobeDataLayer = new adobeDataLayerWrapper();
    let isSummaryPageLoaded = adobeDataLayer.getCookie('summaryPageLoaded');
    if (isSummaryPageLoaded !== 'true') {
        adobeDataLayer.setCookie('summaryPageLoaded', true, 30);
        window.adobeDataLayer.push('pageLoaded', {
            'pageName': 'mas:my:en:enrich-portal:home:summary',
            'pageType': 'Enrich Summary Page',
        });
    }
	let membergrv = new memberPointsExchange();	
    membergrv.enrichstatus();
    membergrv.enrichstatusbenefit();
	} catch(e) {console.error(e);}
}